import { Box, Skeleton } from '@mui/material';

const CHART_HEIGHT_DEFAULT = 300;

export function CalculatorResultsGraphSkeleton() {
  return (
    <Box
      data-testid="calculator-results-graph-skeleton"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        paddingX: '1rem',
        minHeight: CHART_HEIGHT_DEFAULT,
        overflowX: 'hidden',
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: CHART_HEIGHT_DEFAULT,
          minHeight: CHART_HEIGHT_DEFAULT,
          display: 'flex',
          alignItems: 'flex-end',
          gap: {
            xs: '1rem',
            sm: '2rem',
          },
          px: 2.5,
          pb: 3,
          pt: 2,
        }}
      >
        {[0.4, 0.65, 0.85, 0.6, 0.95].map((heightRatio, i) => (
          <Skeleton
            key={i}
            variant="rounded"
            sx={{
              flex: 1,
              maxWidth: 48,
              height: `${heightRatio * 100}%`,
              borderRadius: '8px 8px 0 0',
              padding: {
                xs: '.5rem',
                sm: '1rem',
                md: '2rem',
                lg: '3rem',
                xl: '3.5rem',
                xxl: '4rem',
              },
            }}
          />
        ))}
      </Box>
      <Box
        sx={{
          alignContent: 'center',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'row',
          gap: '1rem',
          justifyContent: 'center',
        }}
      >
        {[1, 2, 3].map(i => (
          <Box
            key={i}
            sx={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'row',
              gap: 0.25,
              justifyContent: 'center',
            }}
          >
            <Skeleton variant="circular" sx={{ width: 14, height: 14 }} />
            <Skeleton variant="rounded" sx={{ width: 72, height: 14, borderRadius: 1 }} />
          </Box>
        ))}
      </Box>
    </Box>
  );
}
